import { render, staticRenderFns } from "./BusinessViewDescription.vue?vue&type=template&id=e8231232&scoped=true&"
import script from "./BusinessViewDescription.vue?vue&type=script&lang=js&"
export * from "./BusinessViewDescription.vue?vue&type=script&lang=js&"
import style0 from "./BusinessViewDescription.vue?vue&type=style&index=0&id=e8231232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8231232",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VIcon,VImg,VRow})
